import { apiFetch } from '../config/api';
import { GalleryEvent } from '../types/Gallery';

class GalleryService {
  // For admin/protected access - should use admin API
  async getAllGalleryEvents(): Promise<GalleryEvent[]> {
    return await apiFetch('/api/admin/gallery/events');
  }

  // For public access - uses public API
  async getPublicGalleryEvents(): Promise<GalleryEvent[]> {
    return await apiFetch('/api/gallery/events');
  }

  // For public access - single event
  async getGalleryEventById(id: string): Promise<GalleryEvent> {
    return await apiFetch(`/api/gallery/events/${id}`);
  }

  // For public access - events by choir
  async getGalleryEventsByChoir(choirId: string): Promise<GalleryEvent[]> {
    return await apiFetch(`/api/gallery/events/choir/${choirId}`);
  }

  // Note: This endpoint doesn't exist in your controllers - may need to be added or removed
  async getGalleryEventsByEventType(eventType: string): Promise<GalleryEvent[]> {
    return await apiFetch(`/api/gallery/events/type/${eventType}`);
  }
}

export default new GalleryService();
